/* eslint-disable prefer-destructuring */
import React, {createRef} from "react";
import PropTypes from "prop-types";
import moment from "moment-timezone";
import { Select, MenuItem, InputLabel, FormControl, Checkbox, ListItemText } from "@mui/material";
import ReactTable from "react-table";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import swal from "sweetalert2";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ReactModal from "react-modal";
import "react-table/react-table.css";
import { forceToMonFri } from "../../components/DateFunction";
import AccomodationAvailability from "./AccomodationAvailabilty";
import ExportTable from "./ExportTable";
import FilterWithAuth from "../../components/FilterWithAuth";
import { createFetch, str2Val, multiSort } from "../../utils";
import defaultColPick, { filterByView } from "./guestColumnConfig";
import { FlightInfoRedux } from "../RoomOverview/components/FlightInfo";
import lang from "../../lang";
import { setDefaultView } from "../../store/user";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
// import { auto } from "eol";
const { URL_PREFIX } = window;

class GuestList extends React.Component {
  constructor(props) {
    super(props);
    const { params } = props.match;
    const url = new URL(window.location.href);
    const viewId =
      url.searchParams.get("viewId") || props.user.info.defaultView;
    this.state = {
      guestList: [],
      flightInfo: {},
      loading: false,
      accomodationInfo: [],
      accomodationShown: false,
      flightInfoShown: false,
      selectedDate: moment(params.date),
      pageSize: 10,
      showFreeze: false,
      freezeColumn: [],
      viewId: !/^(?=[a-f\d]{24}$)(\d+[a-f]|[a-f]+\d)/i.test(viewId)
        ? null
        : viewId,
      viewingList: [],
      roomAssignedModal: {
        id: null,
        show: false,
      },
      rooms: [],
      roomAssignedId: null,
      tableWidth: 0
    };
    this.defineColumn = this.defineColumn.bind(this);
    this.defineSortOrder = this.defineSortOrder.bind(this);
    this.findGuestist = this.findGuestist.bind(this);
    this.onViewChanged = this.onViewChanged.bind(this);
    this.saveRoomAssigned = this.saveRoomAssigned.bind(this);
    this.export = this.export.bind(this);
    this.setDefaultView = this.setDefaultView.bind(this);
    this.getFieldInfo = this.getFieldInfo.bind(this);
    this.strObj = this.strObj.bind(this);

    this.topScrollbar = React.createRef();
    this.tableWrapperRef = React.createRef();
  }

  componentDidMount() {
    this.updateTableWidth();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.guestList !== this.props.guestList) {
      this.updateTableWidth();
    }
  }

  updateTableWidth = () => {
    if (this.tableWrapperRef.current) {
      const rtTable = this.tableWrapperRef.current.querySelector(".rt-table");
      const thead = rtTable?.querySelector(".rt-thead");
      const tbody = rtTable?.querySelector(".rt-tbody");

      if (thead && tbody) {
        const maxWidth = Math.max(thead.scrollWidth, tbody.scrollWidth);
        this.setState({ tableWidth: maxWidth });
        this.rtTable = rtTable; 
      }
      this.rtTable.addEventListener("scroll", this.handleTableScroll);
    }
  };

  handleTopScroll = () => {
    if (this.rtTable && this.topScrollbar.current) {
      this.rtTable.scrollLeft = this.topScrollbar.current.scrollLeft;
    }
  };

  handleTableScroll = () => {
    if (this.rtTable && this.topScrollbar.current) {
      this.topScrollbar.current.scrollLeft = this.rtTable.scrollLeft;
    }
  };


  async componentWillMount() {
    // this.findGuestist();
    await this.getView();
    await this.getRooms();
  }

  async onViewChanged(e) {
    await this.setState({ viewId: e.target.value });
    await this.findGuestist(true);
  }
  async getRooms(forceRefresh = false) {
    // if (this.state.loading) return;
    // this.setState({ loading: true });
    const { user } = this.props;
    const rooms = await createFetch({
      path: `guest/rooms-available?forceRefresh=true`,
      method: "GET",
      accessToken: user.accessToken,
    });
    if (rooms.status === 200) {
      this.setState({ rooms: rooms.records, loading: false });
    }
  }
  async getView() {
    this.setState({ loading: true });
    const { user } = this.props;
    let { viewId } = this.state;
    const viewingList = await createFetch({
      path: "guest/column-viewing",
      method: "GET",
      accessToken: user.accessToken,
    });
    if (viewingList.status === 200) {
      if (viewId === null && viewId !== "Default") {
        const defaultView = viewingList.records.find(
          (o) => o.isDefault === true
        );
        if (defaultView) viewId = defaultView._id;
      }
    }
    await this.setState({
      viewingList: viewingList.records,
      loading: false,
      viewId,
    });
    await this.findGuestist(true);
  }

  getFieldInfo(objDesc, objectName, fieldName) {
    const objectDetail = objDesc.find((o) => o.name === objectName);
    return objectDetail.fields.find((o) => o.name === fieldName);
  }

  async setDefaultView(e) {
    e.preventDefault();
    createFetch({
      path: "users/me/defaultView",
      method: "PATCH",
      accessToken: this.props.user.accessToken,
      body: {
        viewId: this.state.viewId,
      },
    });
    this.props.setDefaultView(this.state.viewId);
  }

  async findGuestist(forceRefresh = false) {
    // const { params } = this.props.match;
    const { viewId } = this.state;
    const { user } = this.props;
    const { selectedDate } = this.state;
    this.setState({ loading: true });

    try {
      const requests = [];
      let path = `guest/query?date=${selectedDate.format(
        "YYYY-MM-DD"
      )}&forceRefresh=${forceRefresh.toString()}`;
      if (viewId) {
        path += `&viewId=${viewId}`;
      }
      requests.push(
        createFetch({
          path,
          accessToken: user.accessToken,
          method: "GET",
        })
      );

      requests.push(
        createFetch({
          path: `ama/flight-by-date?date=${selectedDate.format(
            "YYYY-MM-DD"
          )}&forceRefresh=${forceRefresh}`,
          accessToken: user.accessToken,
          method: "GET",
        })
      );
      requests.push(
        createFetch({
          path: `ama/accomodation-availability?date=${selectedDate.format(
            "YYYY-MM-DD"
          )}`,
          accessToken: user.accessToken,
          method: "GET",
        })
      );
      const results = await Promise.all(requests);
      const flightInfo = {
        in: results[1].records.find(
          (o) =>
            o.RecordType.Name === "IN-Flight" &&
            o.Flight_Type__c !== "Alternative" && o.Flight_Status__c !== 'Cancelled'
        ),
        out: results[1].records.find(
          (o) =>
            o.RecordType.Name === "OUT-Flight" &&
            o.Flight_Type__c !== "Alternative" && o.Flight_Status__c !== 'Cancelled'
        ),
      };
      const guestListData = results[0].records.map((x) => {
        const Guest_FullName__r = x.Guest_FullName__r || {};
        let OtherAddress = "";
        if (
          Guest_FullName__r.OtherAddress !== null &&
          typeof Guest_FullName__r.OtherAddress === "object"
        ) {
          OtherAddress = this.strObj(Guest_FullName__r.OtherAddress);
        }
        Guest_FullName__r.OtherAddress = OtherAddress;
        return {
          ...x,
          Guest_FullName__r,
        };
      });
      const { records: availability } = results[2];
      await this.setState({
        guestList: guestListData,
        loading: false,
        flightInfo,
        accomodationInfo: availability,
        pageSize: results[0].records.length,
      });
      this.updateTableWidth();
    } catch (error) {
      swal.fire({
        title: "Failed to request",
        text: error.message,
        icon: "error",
      });
      this.setState({ loading: false });
    }
  }

  strObj(value) {
    let eleminate = Object.fromEntries(
      Object.entries(value).filter(([_, v]) => v != null)
    );
    let string = "";
    Object.keys(eleminate).forEach((x, i) => {
      string += `${eleminate[x]}`;
      if (i !== Object.keys(eleminate).length - 1) {
        string += ", ";
      }
    });
    return string;
  }

  defineColumn() {
    const {
      guestList: passangerList,
      viewId,
      viewingList,
      selectedDate,
      freezeColumn
    } = this.state;
    const { objDesc } = this.props;
    if (viewId) {
      const selectedViewDetail = viewingList.find((o) => o._id === viewId);
      return filterByView(
        objDesc,
        selectedViewDetail,
        passangerList,
        {
          changeRoomAssigned: (id) =>
            this.setState({
              roomAssignedModal: {
                show: true,
                id,
              },
            }),
        },
        selectedDate,
        freezeColumn
      );
    }
    return defaultColPick(passangerList);
  }

  defineSortOrder() {
    const { viewId, viewingList, guestList } = this.state;
    const { objDesc } = this.props;
    const sortOrder = {};

    if (viewId) {
      const selectedViewDetail = viewingList.find((o) => o._id === viewId);
      if (selectedViewDetail) {
        selectedViewDetail.sortOrder.forEach((e, eindex) => {
          const fieldInfo = this.getFieldInfo(
            objDesc,
            e.objectName,
            e.columnName
          );
          const columnName = `sort_${eindex}`;
          sortOrder[columnName] = e.type;

          guestList.forEach((o, index) => {
            const objMapping = {
              Sales_Order__c: o.Sales_Order_No__r ? o.Sales_Order_No__r : null,
              Guest__c: o,
              Opportunity: o.Sales_Order_No__r
                ? "Opportunity_Name_r" in o.Sales_Order_No__r
                  ? o.Sales_Order_No__r.Opportunity_Name__r
                  : null
                : null,
              Segment__c: o.segment ? o.segment : null,
              Room_Allocation__c: o.segment
                ? "Room_Allocation__r" in o.segment
                  ? o.segment.Room_Allocation__r
                  : null
                : null,
              FormulaField: o,
              Account: o.Sales_Order_No__r
                ? "Account_Name__r" in o.Sales_Order_No__r
                  ? o.Sales_Order_No__r.Account_Name__r
                  : null
                : null,
              Contact: o.Guest_FullName__r ? o.Guest_FullName__r : null,
            };
            if (fieldInfo.type === "reference") {
              if (
                objMapping[e.objectName] &&
                objMapping[e.objectName][e.columnName.replace("__c", "__r")]
              ) {
                guestList[index][columnName] =
                  "Name" in
                  objMapping[e.objectName][e.columnName.replace("__c", "__r")]
                    ? objMapping[e.objectName][
                        e.columnName.replace("__c", "__r")
                      ].Name
                    : "";
              } else {
                guestList[index][columnName] = "";
              }
            } else if (
              objMapping[e.objectName] &&
              objMapping[e.objectName][e.columnName]
            ) {
              guestList[index][columnName] =
                objMapping[e.objectName][e.columnName];
            } else {
              guestList[index][columnName] = "";
            }
          });
        });
      }
    }

    return sortOrder;
  }

  // async export() {
  //   try {
  //     await this.findGuestist();
  //     const { selectedDate } = this.state;

  //     let tableInText = "<table border='2px'><tr bgcolor='#87AFC6'>";
  //     const mimeType = "application/vnd.ms-excel;charset=UTF-16LE";
      
  //     // Get table data
  //     const table = document.getElementById("tableExportGuest");
  //     for (let j = 0; j < table.rows.length; j++) {
  //       tableInText += `${table.rows[j].innerHTML}</tr>`;
  //     }
  //     tableInText += "</table>";

  //     // Remove unwanted HTML elements
  //     tableInText = tableInText.replace(/<A[^>]*>|<\/A>/g, ""); // Remove links
  //     tableInText = tableInText.replace(/<img[^>]*>/gi, ""); // Remove images
  //     tableInText = tableInText.replace(/<input[^>]*>|<\/input>/gi, ""); // Remove input fields

  //     // Wrap table in Excel-compatible HTML template
  //     const template = `
  //       <html xmlns:o="urn:schemas-microsoft-com:office:office"
  //             xmlns:x="urn:schemas-microsoft-com:office:excel" 
  //             xmlns="http://www.w3.org/TR/REC-html40">
  //         <head>
  //           <!--[if gte mso 9]>
  //           <xml>
  //             <x:ExcelWorkbook>
  //               <x:ExcelWorksheets>
  //                 <x:ExcelWorksheet>
  //                   <x:Name>Sheet1</x:Name>
  //                   <x:WorksheetOptions>
  //                     <x:DisplayGridlines/>
  //                   </x:WorksheetOptions>
  //                 </x:ExcelWorksheet>
  //               </x:ExcelWorksheets>
  //             </x:ExcelWorkbook>
  //           </xml>
  //           <![endif]-->
  //         </head>
  //         <body>${tableInText}</body>
  //       </html>
  //     `;

  //     // Convert HTML template to UTF-16LE
  //     const utf16Bytes = new TextEncoder("utf-16le").encode(template);
  //     const blob = new Blob([utf16Bytes], { type: mimeType });

  //     // Create a download link
  //     const link = document.createElement("a");
  //     link.download = `WakatobiGuest-${selectedDate.format("DD MMM YYYY")}.xls`;
  //     link.href = URL.createObjectURL(blob);
  //     document.body.appendChild(link);
  //     link.click();

  //     // Clean up
  //     document.body.removeChild(link);
  //   } catch (err) {
  //     swal.fire({
  //       text: err.message,
  //       title: "An error occurred when exporting the report",
  //       dangerMode: true,
  //     });
  //   }
  // }

  async export() {
    try {
      await this.findGuestist();
      const { selectedDate } = this.state;

      // Create a new workbook and worksheet
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Guest List");

      // Get table data
      const table = document.getElementById("tableExportGuest");
      const rows = Array.from(table.rows);

      // Add rows to the worksheet
      rows.forEach((row) => {
        const cells = Array.from(row.cells).map((cell) => cell.innerText);
        worksheet.addRow(cells);
      });

      // Apply some basic styling (optional)
      worksheet.columns.forEach((column) => {
        column.width = 20; // Set column width
      });

      worksheet.eachRow((row, rowNumber) => {
        if (rowNumber === 1) {
          // Bold the header row
          row.font = { bold: true };
          row.eachCell((cell) => {
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "FF87AFC6" }, // Light blue background
            };
          });
        }
      });

      // Export as .xlsx
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(blob, `WakatobiGuest-${selectedDate.format("DD MMM YYYY")}.xlsx`);
    } catch (err) {
      swal.fire({
        text: err.message,
        title: "An error occurred when exporting the report",
        dangerMode: true,
      });
    }
  }

  async saveRoomAssigned() {
    const { roomAssignedModal, loading, roomAssignedId } = this.state;
    const { user } = this.props;
    if (loading) return;
    this.setState({ loading: true });
    try {
      const result = await createFetch({
        path: "guest/room-assigned",
        method: "PATCH",
        accessToken: user.accessToken,
        body: {
          roomAllocationId: roomAssignedModal.id,
          roomId: roomAssignedId,
        },
      });
      if (result.status === 200) {
        swal.fire({
          title: lang.common.success,
          text: "Room assignment succesfully updated.",
          type: "success",
        });
        this.setState(
          { loading: false, roomAssignedModal: { show: false, id: null } },
          () => this.findGuestist(true)
        );
        return;
      }
      const error = new Error();
      error.message = result.message;
      throw error;
    } catch (error) {
      this.setState({ loading: false });
      swal.fire({
        title: lang.titleError,
        type: "warning",
        html: error.message,
      });
    }
  }

  render() {
    const { user } = this.props;
    const {
      guestList,
      loading,
      //   flightInfo,
      accomodationInfo,
      flightInfoShown,
      accomodationShown,
      selectedDate,
      pageSize,
      viewingList,
      viewId,
      roomAssignedModal,
      rooms,
      freezeColumn,
    } = this.state;
    const columns = this.defineColumn();
    const sortOrder = this.defineSortOrder();
    const selectedRowEdit = guestList.find(
      (o) => o.segment && o.segment.Room_Allocation__c === roomAssignedModal.id
    );
    const viewItem = viewingList?.find((o) => o._id === viewId);

    viewingList.sort((a, b) => {
      const x = a.viewName.toLowerCase();
      const y = b.viewName.toLowerCase();
      if (x < y) {
        return -1;
      }
      if (x > y) {
        return 1;
      }
      return 0;
    });

    return (
      <div className="row" id="passangerInfo">
        <h3>&nbsp;Guest Overview of {selectedDate.format("DD MMM YYYY")}</h3>
        {loading ? (
          <p className="text-center" style={{ fontSize: 16 }}>
            Fetching Data...
            <br />
            <br />
            <i className="fa fa-spinner fa-spin fa-3x" />
          </p>
        ) : null}
        <div className="row" style={{ margin: "10px auto", marginBottom: 0 }}>
          <div className="col-lg-4 col-sm-6 date-selection">
            <div className="item">
              <p>Select view name</p>
              <select
                className="form-control"
                onChange={this.onViewChanged}
                value={viewId}
              >
                {/* <option value="">Default</option> */}
                {viewingList.map((o) => (
                  <option value={o._id} key={o._id} selected={o.isDefault}>
                    {o.viewName}
                  </option>
                ))}
              </select>
              <div
                className="flex"
                style={{ textAlign: "center", flexWrap: "wrap" }}
              >
                <FilterWithAuth
                  authRequired={["menu:Apps:guestList:createNewView"]}
                >
                  <Link
                    to={`${URL_PREFIX}/app/column-config/new`}
                    style={{ marginRight: 10 }}
                  >
                    Create
                  </Link>
                  {viewId ? (
                    <React.Fragment>
                      <p style={{ marginRight: 10 }}>|</p>
                      <Link
                        to={`${URL_PREFIX}/app/column-config/${
                          this.state.viewId || "new"
                        }?date=${selectedDate.format("YYYY-MM-DD")}`}
                      >
                        Edit
                      </Link>
                      <p style={{ margin: "0 10px" }}>|</p>
                      <Link
                        to={`${URL_PREFIX}/app/column-config/${
                          this.state.viewId || "new"
                        }?date=${selectedDate.format("YYYY-MM-DD")}&clone=true`}
                      >
                        Clone
                      </Link>
                    </React.Fragment>
                  ) : null}
                </FilterWithAuth>
                {user.info.defaultView === viewId ? null : (
                  <React.Fragment>
                    <p style={{ margin: "0 10px" }}>|</p>
                    <Link to={URL_PREFIX} onClick={this.setDefaultView}>
                      Set as Default
                    </Link>
                  </React.Fragment>
                )}
              </div>
            </div>
            <FilterWithAuth authRequired={["menu:Apps:guestList:changeDate"]}>
              <div className="item">
                <p>Change date</p>
                <DatePicker
                  selected={selectedDate.toDate()}
                  onChange={async (val) => {
                    const selected = await forceToMonFri(val);
                    await this.setState({ selectedDate: moment(selected) });
                    await this.findGuestist(true);
                  }}
                  dateFormat="dd-MMM-yyyy"
                  className="form-control"
                  locale={user.language}
                  showMonthDropdown
                  showYearDropdown
                />
                <span style={{ marginLeft: 10 }}>
                  <button
                    className="btn btn-default"
                    onClick={() => this.findGuestist(true)}
                    style={{ backgroundColor: "#5AC4CF" }}
                  >
                    <i className="fa fa-sync" />
                  </button>
                </span>
              </div>
            </FilterWithAuth>
          </div>
          <div className="col-lg-8 pull-right col-sm-6 btn-information-section">
            <FilterWithAuth
              authRequired={["menu:Apps:guestList:viewFlightInfo"]}
            >
              <button
                className="btn"
                style={{ backgroundColor: "#2899D5" }}
                onClick={() => this.setState({ flightInfoShown: true })}
              >
                <i className="fa fa-plane" /> Flight Information
              </button>
            </FilterWithAuth>
            <FilterWithAuth
              authRequired={[
                "menu:Apps:guestList:viewAccomodationAvailability",
              ]}
            >
              <button
                className="btn"
                style={{ backgroundColor: "#103290" }}
                onClick={() => this.setState({ accomodationShown: true })}
              >
                <i className="fa fa-hotel" /> Accomodation Availability
              </button>
            </FilterWithAuth>
            <FilterWithAuth
              authRequired={["menu:Apps:guestList:exportToExcel"]}
            >
              <button
                className="btn"
                style={{ backgroundColor: "#2E9010" }}
                onClick={this.export}
              >
                <i className="fa fa-file-excel" /> Export to Excel
              </button>
            </FilterWithAuth>
          </div>
        </div>

        <div style={{padding: '0 10px', position: 'relative', paddingBottom: '10px'}}>
          <p style={{
            color: '#337ab7',
            cursor: 'pointer',
            marginBottom: '1px'
          }} onClick={() => this.setState({showFreeze: !this.state.showFreeze})}>
            Freeze Column
          </p>
          {this.state.showFreeze &&
            <Select
              multiple
              value={freezeColumn}
              onChange={(e) => this.setState({ freezeColumn: e.target.value })}
              displayEmpty
              renderValue={(selected) => {
                if (selected.length === 0) {
                  return "- No Column -";
                }
                const selectedLabels = viewItem?.column
                  .filter(item => selected.includes(item.columnName))
                  .map(item => item.label);
                
                return selectedLabels.join(", ");
              }}
              sx={{
                fontSize: '18px', 
                width: '50vw', 
                '& .MuiMenu-paper': {
                  maxHeight: '300px',  // Set max height for the dropdown
                  overflowY: 'auto',   // Make it scrollable
                },
              }}
            >
              <MenuItem value="">
                <em>- No Column -</em>
              </MenuItem>
              {viewItem?.column.map((o, i) => (
                <MenuItem
                  key={i}
                  value={o.columnName}
                  sx={{
                    fontSize: '18px !important', // Ensure the font size for each MenuItem
                    width: 'auto', // Adjust width here to prevent stretching
                    maxWidth: '200px !important', // You can adjust this width to your needs
                    whiteSpace: 'nowrap', // Prevent the text from wrapping
                    overflow: 'hidden', // Hide any overflow text
                    textOverflow: 'ellipsis', // Add ellipsis if the text overflows
                  }}
                >
                  <Checkbox checked={freezeColumn.indexOf(o.columnName) > -1} />
                  <ListItemText primary={o.label} />
                </MenuItem>
              ))}
            </Select>
          }
        </div>

        <div
          ref={this.topScrollbar}
          className="top-scrollbar"
          style={{
            overflowX: "auto",
            height: "15px",
            width: "100%",
          }}
          onScroll={this.handleTopScroll}
        >
          <div style={{ width: this.state.tableWidth, height: "1px" }} />
        </div>

        <div 
          ref={this.tableWrapperRef} 
          className="table-responsive" 
          style={{ overflowX: 'auto', position: 'relative' }}
        >
          <ReactTable
            columns={columns}
            data={multiSort(guestList, sortOrder)}
            defaultPageSize={pageSize}
            className="-striped -highlight guest-table"
            defaultSorting="segment.Segment_Type__c"
            sortable={false}
            loading={loading}
            pageSize={pageSize}
            onPageSizeChange={(size) => this.setState({ pageSize: size })}
            // pivotBy={['segment.Segment_Type__c']}
          />
          <table className="table table-bordered" style={{ display: "none" }}>
            <thead>
              <tr>
                <th>#</th>
                <th>Salesperson</th>
                <th>SO Number</th>
                <th>Flight</th>
                <th>Nationality</th>
                <th>Guest Name</th>
                <th>Contact Person</th>
                <th style={{ width: 20 }}>
                  Total <br />
                  Room Nights
                </th>
                <th>Visit Status</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Room Type</th>
                <th style={{ width: 100 }}>
                  Total <br />
                  Invoice Amount
                </th>
              </tr>
            </thead>
            <tbody>
              {guestList.map((person, index) => (
                <tr key={person.Id}>
                  <td>{index + 1}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <ReactModal
          id="flightModal"
          overlayClassName="overlay-ama"
          className="ama-modal"
          isOpen={flightInfoShown}
          closeTimeoutMS={0}
          ariaHideApp={false}
          onRequestClose={() => this.setState({ flightInfoShown: false })}
        >
          {flightInfoShown && (
            <FlightInfoRedux flightInfo={this.state.flightInfo} />
          )}

          <div className="close-btn">
            <button
              onClick={() => this.setState({ flightInfoShown: false })}
              className="btn"
            >
              <i className="fa fa-times fa-2x" />
            </button>
          </div>
        </ReactModal>
        <ReactModal
          id="changeRoomAssigned"
          overlayClassName="overlay-ama"
          className="ama-modal"
          isOpen={roomAssignedModal.show}
          closeTimeoutMS={0}
          ariaHideApp={false}
          onRequestClose={() =>
            this.setState({ roomAssignedModal: { show: false, id: null } })
          }
        >
          <h2>
            Update Room Assignment &nbsp;
            <button
              disabled={loading}
              className="btn btn-xs btn-default"
              onClick={() => this.getRooms(true)}
            >
              <i className="fa fa-sync" />
            </button>
          </h2>
          <p>
            {selectedRowEdit
              ? str2Val(columns[1].accessor || "", selectedRowEdit)
              : null}
          </p>
          <select
            value={this.state.roomAssignedId}
            className="form-control"
            onChange={(e) => this.setState({ roomAssignedId: e.target.value })}
          >
            <option />
            {rooms.map((o) => (
              <option value={o.Id}>
                {o.Name} - {o.RoomType__c}
              </option>
            ))}
          </select>
          <div className="flex" style={{ width: "50%", margin: "20px auto" }}>
            <button
              className="btn btn-default"
              onClick={() =>
                this.setState({ roomAssignedModal: { show: false, id: null } })
              }
              style={{ flex: 1 }}
            >
              <i className="fa fa-arrow-left" /> {lang.common.cancel}
            </button>
            <button
              disabled={loading}
              className="btn btn-alternate"
              onClick={this.saveRoomAssigned}
              style={{ flex: 1 }}
            >
              <i className="fa fa-save" /> {lang.common.save}
            </button>
          </div>
        </ReactModal>
        <AccomodationAvailability
          data={accomodationInfo}
          visible={accomodationShown}
          toggleVisibility={() =>
            this.setState({ accomodationShown: !accomodationShown })
          }
        />
        <ExportTable data={multiSort(guestList, sortOrder)} column={columns} />
      </div>
    );
  }
}

GuestList.propTypes = {
  match: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  objDesc: PropTypes.array.isRequired,
  setDefaultView: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setDefaultView: (payload) => ({
        type: setDefaultView,
        payload,
      }),
    },
    dispatch
  );

const mapStateToProps = (state) => ({
  user: state.user,
  objDesc: state.salesforce.objDesc,
});

export default connect(mapStateToProps, mapDispatchToProps)(GuestList);
